import reports from "@/mixins/dictionaries/reports";

export default function getReportName(type) {
    return Object.keys(reports).find(k => reports[k] === type) ?? 'Тестирование';
}